import { Injectable } from '@angular/core';

import { toCent } from '@frontend/sports/common/core/utils/math';
import { TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

export interface MyBetsEarlyPayoutButtonTrackingModel {
    earlyPayoutValue: number;
    earlyPayoutSlipID: string;
    containsLiveBets: boolean;
    context: string;
    isPushUpdate?: boolean;
    betType: string;
    isFreeBet: boolean;
    isCashout?: boolean;
}

@Injectable({ providedIn: 'root' })
export class MyBetsEarlyPayoutButtonTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackCashoutClick(trackModel: MyBetsEarlyPayoutButtonTrackingModel): void {
        const trackingData = {
            ...this.getBaseTrackingData(trackModel),
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'click',
        };
        this.trackingService.track(trackingConstants.EVENT_EARLYPAYOUT, trackingData);
    }

    trackCashoutConfirm(trackModel: MyBetsEarlyPayoutButtonTrackingModel): void {
        const trackingData = {
            ...this.getBaseTrackingData(trackModel),
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'sent',
        };
        this.trackingService.track(trackingConstants.EVENT_EARLYPAYOUT, trackingData);
    }

    trackCashoutResetPreparing(trackModel: MyBetsEarlyPayoutButtonTrackingModel): void {
        this.trackingService.track(trackingConstants.EVENT_EARLYPAYOUT, {
            ...this.getBaseTrackingData(trackModel),
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'click_confirm_reset',
            pushUpdate: trackModel.isPushUpdate ? true : false,
        });
    }

    private getBaseTrackingData(trackModel: MyBetsEarlyPayoutButtonTrackingModel): Partial<TrackData> {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'early payout',
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'attempt',
            earlyPayoutAmount: toCent(trackModel.earlyPayoutValue),
            earlyPayoutSlipID: trackModel.earlyPayoutSlipID,
            [trackingConstants.COMPONENT_LOCATION_EVENT]:
                (trackModel.containsLiveBets ? 'live/earlypayout' : 'main/earlypayout') + trackModel.context,
            [trackingConstants.COMPONENT_POSITION_EVENT]: trackModel.betType,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: trackModel.isFreeBet ? 'freebet' : 'real money bet',
        };
    }
}
